/* Swarva accordions: slide answers open and closed instead of jumping.
   Works on every Swarva FAQ (homepage, product hero, product page FAQ)
   through one delegated click handler, so sections added later in the
   theme editor pick it up too. The panel is the element right after
   <summary>. Opening one closes any other open question in the same list,
   so only one answer shows at a time. Reduced-motion users get instant
   toggles. */
(function () {
  var SELECTOR = '.sw-faq__item, .sw-buy__faq-item, details[data-sw-accordion]';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  var collapse = function (d, animate) {
    var panel = d.querySelector('summary') && d.querySelector('summary').nextElementSibling;
    /* Stop a slide that is still running so it can't leave this one open */
    if (panel && panel.getAnimations) panel.getAnimations().forEach(function (a) { a.onfinish = null; a.cancel(); });
    delete d.dataset.swAnim;
    if (!animate || !panel || !panel.animate) { d.open = false; return; }
    d.dataset.swAnim = '1';
    panel.animate(
      [{ height: panel.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
      { duration: 220, easing: 'cubic-bezier(0.4, 0, 0.6, 1)' }
    ).onfinish = function () { d.open = false; delete d.dataset.swAnim; };
  };

  /* Close the other open questions in the same list */
  var closeSiblings = function (d, animate) {
    /* Items wrapped in their own blocks (landing pages) share a [data-sw-accordion-group] ancestor */
    var group = d.closest('[data-sw-accordion-group]');
    var list = group || d.parentElement;
    if (!list) return;
    var items = group ? list.querySelectorAll(SELECTOR) : list.children;
    Array.prototype.forEach.call(items, function (other) {
      if (other !== d && other.open && other.matches(SELECTOR)) collapse(other, animate);
    });
  };

  document.addEventListener('click', function (e) {
    var q = e.target.closest('summary');
    if (!q) return;
    var d = q.parentElement;
    if (!d || !d.matches(SELECTOR)) return;
    var panel = q.nextElementSibling;
    if (!panel || !panel.animate || reduce.matches) {
      if (!d.open) closeSiblings(d, false);
      return;
    }

    e.preventDefault();
    if (d.dataset.swAnim) return;
    d.dataset.swAnim = '1';
    var done = function () { delete d.dataset.swAnim; };

    if (!d.open) {
      closeSiblings(d, true);
      d.open = true;
      panel.animate(
        [{ height: '0px', opacity: 0 }, { height: panel.scrollHeight + 'px', opacity: 1 }],
        { duration: 280, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)' }
      ).onfinish = done;
    } else {
      panel.animate(
        [{ height: panel.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
        { duration: 220, easing: 'cubic-bezier(0.4, 0, 0.6, 1)' }
      ).onfinish = function () { d.open = false; done(); };
    }
  });
})();
